import { render, staticRenderFns } from "./ListPhones.vue?vue&type=template&id=79c2c8b2"
import script from "./ListPhones.vue?vue&type=script&lang=js"
export * from "./ListPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports